<template>
<div class="modal">
  <div class="sub_modal">
    <span class="close" @click="$emit('cerrarModal')">x</span>
    <div>
      <h3>Datos extraídos de Open Weather Map API</h3>
      <ul class="datos">
        <li>tempeartura: {{tiempo.temperatura}}ºC</li>
        <li>nubes: {{tiempo.nubes}}</li>
        <li>probabilidad de lluvia en las próximas 4 horas: {{tiempo.lluvia}}%</li>
        <li>viento: {{tiempo.viento}} m/s</li>
      </ul>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Datos',
  components: {},
  props: {
    tiempo: {}
  },
  data() {
    return {
      
    }
  },
  created: function() {
  },
  mounted: function() {
  },
  methods: {
  }
}
</script>
<style scoped lang="scss">
.modal {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  background-color: rgba(255,255,255,.25);
  backdrop-filter: blur(10px);
  .sub_modal {
    width: 90%;
    min-height: 60%;
    background-color: rgba(255,255,255,.9);
    backdrop-filter: blur(10px);
    border-radius: 1em;
    padding: 1em;
    display: flex;
    align-items: center;
    .close {
      position: absolute;
      top: .5em;
      right: .6em;
      font-weight: bold;
      font-size: 1.3rem;
      cursor: pointer;
    }
    h3 {
      font-weight: bold;
      margin-bottom: 2em;
      text-align: left;
    }
    .datos {
      text-align: left;
      margin-bottom: 3em;
      li {margin-bottom: .7em}
    }
  }
}
</style>
